module.exports = __webpack_public_path__ + "img/services-main.bf544c04.png";